module.exports = __webpack_public_path__ + "img/6.02559c4.png";